<template>
    <div data-cy="section_error_main">
        <pre data-cy="text_error_message">{{message}}</pre>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            message: '',
        }
    },
    created: function () {
        let isShowErrorEnable = window.showErrorMode

        if (isShowErrorEnable === true) {
            this.showError()
        } else {
            this.$router.replace('/error')
        }
    },
    methods: {
        showError: function () {
            let str = this.$route.query.message
            try {
                let json = JSON.parse(str);
                json = JSON.stringify(json, null, 2)
                this.message = json
            } catch (e) {
                this.message = str
            }
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
